import React from 'react';

function FilterShimmer({ columns = 1, rows = 10 }) {
    return (
        <tbody>
            {[...Array(rows)].map((_, rowIndex) => (
                <tr className="animate-pulse" key={rowIndex}>
                    {[...Array(columns)].map((_, colIndex) => (
                        <td key={colIndex} className="text-sm font-light text-[#13365C] py-1 min-w-[325px]">
                            <div className="h-7 bg-slate-200 rounded" />
                        </td>
                    ))}
                </tr>
            ))}
        </tbody>
    );
}

export default FilterShimmer;